import { styled, Box } from '@mui/material';
import { rem } from '@core-web/typography';

export const SnackBarWrapper = styled(Box)(({ theme: { palette } }) => ({
  '.MuiSnackbar-root.MuiSnackbar-anchorOriginBottomRight': {
    bottom: rem(80),
  },
  '.MuiPaper-root': {
    color: palette.colors.white,
  },
  '.MuiAlert-filledSuccess': {
    backgroundColor: palette.colors.green_600,
  },
  '.MuiAlert-filledError': {
    backgroundColor: palette.colors.red,
  },
}));
